(ns ^:dev/always bp-clients.tv-app.api.graphql.license
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/drm/media.graphql"
  "graphql/drm/license.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private license-raw (get-in query-map [:query :drm-license-v-2]))
(def ^:private media-raw (get-in query-map [:query :media]))

(defn license-query
  "Sends a token-valid query"
  ([]
   (license-query nil))
  ([variables]
   (query-builder license-raw (select-keys variables [:media-id :challenge]))))

(defn media-query
  "Sends a token-valid query"
  ([]
   (media-query nil))
  ([variables]
   (query-builder media-raw (select-keys variables [:playlist-id :media-id :hdcp]))))

(comment
  ;; see the corresponding .graphql files for more impormation
  (media-query {:playlist-id "123" :media-id "321" :hdcp false})
  (license-query {:media-id "321" :challenge "chal-token"}))
